class LayoutListener {
  constructor() {
    this.onToggleLabelsCb = null;
    this.onToggleRibbonCb = null;
    this.onChangeLayoutCb = null;
    this.listenToToggleAnnouncementsCb = null;
    this.listenToCloseLayoutCb = null;
    this.listenToNavigateCb = null;

    this.onToggleRibbon = this.onToggleRibbon.bind(this);
    this.onChangeLayout = this.onChangeLayout.bind(this);
    this.onToggleLabels = this.onToggleLabels.bind(this);
    this.closeTab = this.closeTab.bind(this);
    this.navigate = this.navigate.bind(this);
    this.toggleAnnouncements = this.toggleAnnouncements.bind(this);
  }

  listenToToggleLabels(callback) {
    this.onToggleLabelsCb = callback;
  }

  listenToToggleRibbon(callback) {
    this.onToggleRibbonCb = callback;
  }

  listenToChangeLayout(callback) {
    this.onChangeLayoutCb = callback;
  }

  listenToToggleAnnouncements(callback) {
    this.listenToToggleAnnouncementsCb = callback;
  }

  listenToCloseLayout(callback) {
    this.listenToCloseLayoutCb = callback;
  }

  listenToNavigate(callback) {
    this.listenToNavigateCb = callback;
  }

  onToggleLabels() {
    if (this.onToggleLabelsCb) { this.onToggleLabelsCb(); }
  }

  onToggleRibbon() {
    if (this.onToggleRibbonCb) { this.onToggleRibbonCb(); }
  }

  onChangeLayout() {
    if (this.onChangeLayoutCb) { this.onChangeLayoutCb(); }
  }

  toggleAnnouncements() {
    if (this.listenToToggleAnnouncementsCb) { this.listenToToggleAnnouncementsCb(); }
  }

  closeTab(itemsUrls) {
    if (this.listenToCloseLayoutCb) { this.listenToCloseLayoutCb(itemsUrls); }
  }

  navigate(action) {
    if (this.listenToNavigateCb) { this.listenToNavigateCb(action); }
  }
}

const instance = new LayoutListener();

export default instance;
